import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';

import { Fetch } from '@app/models/fetch';
import { Budget } from '@app/models/budgets/budgets.model';
import { Device } from '@app/models/devices/devices.model';

import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class BudgetService {
    constructor(private fetch: Fetch, private router: Router, private route: ActivatedRoute) {}

    get(id: number, ws: Device) {
        return this.fetch.getOne<Budget>(`/devices/${ws.id}/budgets`, id).model(Budget);
    }

    getAll(ws: Device) {
        return this.fetch.getAll<Budget>(`/devices/${ws.id}/budgets`).models(Budget);
    }

    create(ws: Device, budget: Budget) {
        return this.fetch.post<Budget>(`/devices/${ws.id}/budgets`, budget);
    }

    update(ws: Device, id: number, budget: Partial<Budget>) {
        return this.fetch.patch<Budget>(`/devices/${ws.id}/budgets`, id, budget);
    }

    delete(ws: Device, id: number) {
        return this.fetch.delete(`/devices/${ws.id}/budgets`, id);
    }

    navigateToBudgetRange(budget: string, timezone: string) {
        const scale = this.getBudgetRangeScale(budget);
        const params: Record<string, string> = {};
        params.since = DateTime.local().setZone(timezone).startOf(scale).toISO();
        params.until = DateTime.local().setZone(timezone).endOf(scale).toISO();
        params.scale = scale;
        params.new = 'true';

        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: params,
        });
    }

    getBudgetRangeScale(budget: string) {
        switch (budget.toLowerCase()) {
            case 'daily':
                return 'day';
            case 'weekly':
                return 'week';
            case 'monthly':
                return 'month';
            default:
                return 'day';
        }
    }
}
